import { CLASSES } from "../helpers/_global";

export default class Modal {
  constructor() {
    this.modalLink = Array.prototype.slice.call(document.querySelectorAll('.js-modal-link'));
    this.modalEl = Array.prototype.slice.call(document.querySelectorAll('.js-modal'));
    this.modalCloseBtn = Array.prototype.slice.call(document.querySelectorAll('.js-close-modal'));
    this.modalSelector = '.js-modal';
    this.modalElLength = this.modalEl.length;
  }

  init() {
    if (this.modalElLength) {

      $(this.modalEl).on('click', '.js-close-modal', this.deactivateModal.bind(this));
      $(this.modalLink).on('click', this.openTrigger.bind(this));

      this.active = true;
    } else {
      this.active = false;
    }
  }


  openTrigger(e) {
    e.preventDefault();
    const current = e.currentTarget;
    const targetAttr = $(current).attr('data-modal-target');
    const $target = $(`.js-modal[data-modal="${targetAttr}"]`);
    this.open($target);
  }

  deactivateModal(e) {
    e.preventDefault();
    const modal = e.target.closest(this.modalSelector);
    modal.classList.remove(CLASSES.open);
    const $modal = $(modal);
    $modal.fadeOut(200);
    if ($modal.attr('data-modal') === 'video-modal') {
      Modal.removeVideo($modal)
    }
  }

  deactivateAllModals() {
    this.modalEl.forEach(element => {
      element.classList.remove(CLASSES.open);
    });
  }

  open(el) {
    const $modal = $(el);
    this.deactivateAllModals();
    $modal.fadeIn(300);
    $modal.addClass(CLASSES.open);

    if ($modal.attr('data-modal') === 'video-modal') {
      Modal.insertVideo($modal)
    }

  }

  static insertVideo($modal) {
    const $videoWrap = $modal.find('.js-modal-video-wrap');
    const videoUrl = $videoWrap.attr('data-src');
    // const videoType = $videoWrap.attr('data-video-type');
    const $iframe = `<iframe src="${videoUrl}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> `;
    //   const $iframe = `<video width="320" height="240" autoplay>
    //   <source src="${videoUrl}" type="video/${videoType}">
    // </video>`
    $videoWrap.append($iframe);
  }

  static removeVideo($modal) {
    $modal.find('.js-modal-video-wrap').html('');
  }


  static close(el) {
    $(el).fadeOut(200);
    $(el).removeClass(CLASSES.open);
  }
}
